
import React from 'react';

const WeatherTabContent = () => {
  return (
    <div className="text-center p-4">
      <p className="text-sm text-muted-foreground">
        Weather data will be available when connected to a weather API
      </p>
    </div>
  );
};

export default WeatherTabContent;
